import "../../resources/scss/weekly-item.scss"

const WeeklyItem = ({ thumbnail, title, date, file }) => {
  const placeholderImage = "/images/placeholder.jpg"

  return (
      <div className="weekly-item-card">
        <div className="weekly-item-thumbnail">
          <img
              src={thumbnail || placeholderImage}
              alt={title}
              onError={(e) => {
                e.target.src = placeholderImage
              }}
          />
        </div>
        <div className="weekly-item-info">
          <h4 className="weekly-item-title">{title}</h4>
          <div className="weekly-item-meta">
            <i className="far fa-calendar-alt"></i>
            <span>{date}</span>
          </div>
        </div>
        <a href={file} download className="download-button">
          <i className="fas fa-download"></i>
          <span>다운로드</span>
        </a>
      </div>
  )
}

export default WeeklyItem
